import en from "./en.json";
import es from "./es.json";
import pt from "./pt.json";
import ko from "./ko.json";
import ja from "./ja.json";
import fr from "./fr.json";

const translations = { en, es, pt, ko, ja, fr };

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', prefix: '' },
  { code: 'es', label: 'Español', prefix: '/es' },
  { code: 'pt', label: 'Português', prefix: '/pt' },
  { code: 'ko', label: '한국어', prefix: '/ko' },
  { code: 'ja', label: '日本語', prefix: '/ja' },
  { code: 'fr', label: 'Français', prefix: '/fr' },
];

/**
 * Translate a key with optional variable interpolation.
 */
export function t(key, locale = "en", vars = {}) {
  const dict = translations[locale] || translations.en;
  let text = dict[key] || translations.en[key] || key;

  Object.entries(vars).forEach(([varKey, varValue]) => {
    text = text.replace(new RegExp(`\\{\\{${varKey}\\}\\}`, "g"), varValue);
  });

  return text;
}

/**
 * Get supported locale codes.
 */
export function getSupportedLocales() {
  return Object.keys(translations);
}

/**
 * Check if a locale is supported.
 */
export function isLocaleSupported(locale) {
  return locale in translations;
}

/**
 * Extract locale from a URL path.
 * Returns { locale, pathWithoutLocale }.
 */
export function extractLocaleFromPath(path) {
  for (const loc of SUPPORTED_LOCALES) {
    if (loc.prefix && (path === loc.prefix || path.startsWith(loc.prefix + '/'))) {
      return {
        locale: loc.code,
        pathWithoutLocale: path.slice(loc.prefix.length) || '/',
      };
    }
  }
  return { locale: 'en', pathWithoutLocale: path };
}

/**
 * Build a localized path.
 */
export function localizedPath(path, locale) {
  const loc = SUPPORTED_LOCALES.find(l => l.code === locale);
  if (!loc || !loc.prefix) return path;
  return loc.prefix + (path === '/' ? '' : path);
}

export default t;
